import Logout from "./Logout";
import Update from "./Update";

export const User = {
  Update: Update,
  Logout: Logout,
};
